import React, { FC, useEffect, useState } from "react";
import { AuthContext, IAuthUser } from "../../contexts/AuthContext";
import User from "../../api/services/users";

interface IProps {
    children: React.ReactNode
}

export const AuthContainer:FC<IProps> = ({children}) => {
    const [isAuth, setAuth] = useState(false)
    const [user, setUser] = useState<IAuthUser | null>(null)

    useEffect(() => {
        const token = localStorage.getItem("token")

        if(token) setAuth(true)
    }, [])

    // Fetched once here (rather than separately in the Navbar and Settings
    // pages) so both share the same profile fetch instead of duplicating
    // the /users/me/ call.
    useEffect(() => {
        if (!isAuth) {
            setUser(null)
            return
        }

        User.getMe()
            .then(res => setUser(res.data))
            .catch(() => setUser(null))
    }, [isAuth])

    return (
        <AuthContext.Provider value={{isAuth, setAuth, user}}>
            {children}
        </AuthContext.Provider>
    )
}
